import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { MAIN_CONTAINER_WIDTH_XL, useBreakpoints } from '../../hooks';
import { Col } from '../../atoms';
export default function ComponentWeb({ fullHeight = true, paddingBottom = true, children, }) {
    const { breakpoints } = useBreakpoints();
    return (_jsx(Col, { style: [
            $.container,
            fullHeight && $.containerFullHeight,
            // Until we get rid of the previous AppContainer layout,
            // changing padding/margin here requires adjusting the spacing for banners
            // (which are display on both old pages and new ones)
            // look for "useInlineBanners"
            breakpoints.MORE_THAN_OR_EQUAL_L && $.container_L,
            paddingBottom && $.paddingBottom,
        ], children: children }));
}
const $ = StyleSheet.create({
    container: {
        maxWidth: MAIN_CONTAINER_WIDTH_XL,
        width: '100%',
        paddingHorizontal: theme.spacing[4],
    },
    containerFullHeight: {
        flex: 1,
    },
    paddingBottom: {
        paddingBottom: theme.spacing[6],
    },
    container_L: {
        marginHorizontal: 'auto',
        paddingHorizontal: theme.spacing[6],
    },
});
